<template>
	<div class="idi">
		<div class="idi__elm">
			<!-- ///////////// -->
			<!-- BACKWARD LINK -->
			<div class="idi__elm-backward">
				<div class="idi__elm-backward-col">
					<div
						v-if="!device.isMobile"
						class="idi__elm-backward-col-link"
						@click="onGoBack"
					>
						<IconArrowLeft color="rgb(49, 49, 50)" />
					</div>
					<div class="idi__elm-backward-col-label" @click="onGoBack">
						{{ instance.instance }}
					</div>
				</div>
				<div class="idi__elm-backward-col">
					<UiButton
						@click="onModalEventLog"
						label="Последние действия"
						border-color="rgb(223, 230, 238)"
						background-color="rgb(223, 230, 238)"
					/>
				</div>
			</div>

			<!-- ///////////// -->
			<!-- INFO -->
			<div class="idi__elm-info">
				<div v-if="!device.isMobile" class="idi__elm-info-label">
					Информация
				</div>

				<!-- Канал инстанса -->
				<div class="idi__elm-info-item" v-if="instanceChannelName">
					<div class="idi__elm-info-item-key">Канал:</div>
					<div class="idi__elm-info-item-val">
						{{ instanceChannelName }}
					</div>
				</div>

				<!-- Канал активен до -->
				<div class="idi__elm-info-item" v-if="instanceExpired">
					<div class="idi__elm-info-item-key">Канал активен до:</div>
					<div class="idi__elm-info-item-val">
						{{ dataTimeFormat(instanceExpired) }}
					</div>
				</div>

				<!-- API URL -->
				<div class="idi__elm-info-item">
					<div class="idi__elm-info-item-key">API URL:</div>
					<div class="idi__elm-info-item-val">
						{{ instanceApiUrl }}
					</div>
				</div>

				<!-- Id Instance -->
				<div class="idi__elm-info-item">
					<div class="idi__elm-info-item-key">Id Instance:</div>
					<div class="idi__elm-info-item-val">
						{{ instance.instance }}
					</div>
				</div>

				<!-- Api Token Instance -->
				<div class="idi__elm-info-item">
					<div class="idi__elm-info-item-key">Api Token Instance:</div>
					<div class="idi__elm-info-item-val">
						{{ instance.token }}
					</div>
				</div>

				<!-- Статус -->
				<div class="idi__elm-info-item">
					<div class="idi__elm-info-item-key">Статус:</div>
					<div class="idi__elm-info-item-val">
						<UiStatusIndicator :value="Number(instance.status)" />
					</div>
				</div>

				<div class="idi__elm-info-item" v-if="instancePauseStamp">
					<div class="idi__elm-info-item-key">Дата остановки:</div>
					<div class="idi__elm-info-item-val">
						{{ dataTimeFormat(instancePauseStamp) }}
					</div>
				</div>

				<!-- Канал активен до -->
				<div class="idi__elm-info-item" v-if="instanceDeletedStamp">
					<div class="idi__elm-info-item-key">Канал удален:</div>
					<div class="idi__elm-info-item-val">
						{{ dataTimeFormat(instanceDeletedStamp) }}
					</div>
				</div>

				<!-- Телефон -->
				<div class="idi__elm-info-item" v-if="instance.phone">
					<div class="idi__elm-info-item-key">Телефон:</div>
					<div class="idi__elm-info-item-val">
						{{ formatPhoneNumber(instance.phone) }}
					</div>
				</div>

				<!-- Телефон -->
				<div class="idi__elm-info-item" v-if="instance.last_auth_phone">
					<div class="idi__elm-info-item-key">
						Последний авторизованный телефон:
					</div>
					<div class="idi__elm-info-item-val">
						{{ formatPhoneNumber(instance.last_auth_phone) }}
					</div>
				</div>

				<div class="idi__elm-info-item">
					<div class="idi__elm-info-item-key">Опции:</div>
				</div>

				<!-- Опции -->
				<div v-if="instance.status !== STATUS.DELETE">
					<div v-for="(item, index) in paidOptions" :key="index">
						<!-- Desktop -->
						<div class="idi__elm-info-option">
							<div class="idi__elm-info-option-val">
								{{ getOptionById(item.option_id).name }}
							</div>
							<div class="idi__elm-info-option-val">
								до {{ dataTimeFormat(item.expire_stamp) }}
							</div>

							<!-- Switchers -->
							<div class="idi__elm-info-option-checkbox">
								<div class="idi__elm-info-option-checkbox-title">
									Автопродление
								</div>
								<UiSwitcher
									:is-array-items="true"
									:item-id="item.option_id"
									:name="`renewal_${item.option_id}`"
									:is-checked="!!item.need_renew"
									v-on:checked-item="onCheckboxAutoRenew"
								/>
							</div>
						</div>
					</div>
				</div>

				<!-- Разделительная линия -->
				<div class="idi__elm-info-line"></div>

				<!-- ////////////////// -->
				<!-- Нижняя часть блока (Desktop) -->
				<div v-if="!device.isMobile" class="idi__elm-info-footer">
					<!-- EXIT -->
					<div class="idi__elm-info-footer-item">
						<div class="idi__elm-info-footer-item-icon">
							<IconExit
								:color="
									instance.status === STATUS.WAITING ||
									instance.status === STATUS.WAITING_5 ||
									instance.status === STATUS.DELETE ||
									instance.status === STATUS.PROCESS
										? 'rgb(234,234,234)'
										: 'rgb(119, 121, 124)'
								"
							/>
						</div>
						<div
							@click="onLogoutInstance"
							:class="
								instance.status === STATUS.WAITING ||
								instance.status === STATUS.WAITING_5 ||
								instance.status === STATUS.DELETE ||
								instance.status === STATUS.PROCESS
									? 'idi__elm-info-footer-item-label_notactive'
									: 'idi__elm-info-footer-item-label'
							"
						>
							Выйти
						</div>
					</div>

					<!-- RESTART -->
					<div class="idi__elm-info-footer-item">
						<div class="idi__elm-info-footer-item-icon">
							<IconRestart
								:color="
									instance.status === STATUS.DELETE || isClickRebootBtn
										? 'rgb(234,234,234)'
										: '#77797C'
								"
							/>
						</div>
						<div
							@click="onRebootInstance"
							:class="
								instance.status === STATUS.DELETE || isClickRebootBtn
									? 'idi__elm-info-footer-item-label_notactive'
									: 'idi__elm-info-footer-item-label'
							"
						>
							Перезапустить
						</div>
					</div>

					<!-- REMOVE -->
					<div v-if="isShowDeleteAction" class="idi__elm-info-footer-item">
						<div class="idi__elm-info-footer-item-icon">
							<IconTrash
								:color="
									instance.status !== STATUS.DELETE
										? '#E83941'
										: 'rgb(234,234,234)'
								"
							/>
						</div>
						<div
							@click="onDeleteInstance"
							:class="
								instance.status !== STATUS.DELETE
									? 'idi__elm-info-footer-item-label_red'
									: 'idi__elm-info-footer-item-label_grey'
							"
						>
							Удалить
						</div>
					</div>

					<!-- BUTTON - Получить QR-код -->
					<div class="idi__elm-info-footer-item">
						<UiButton
							@click="onGetQrCode"
							label="Получить QR-код"
							:background-color="
								instance.status === STATUS.WAITING ||
								instance.status === STATUS.WAITING_5
									? 'var(--theme-color)'
									: 'rgb(244, 246, 250)'
							"
							:border-color="
								instance.status === STATUS.WAITING ||
								instance.status === STATUS.WAITING_5
									? 'var(--theme-color)'
									: 'rgb(244, 246, 250)'
							"
							color="rgb(255, 255, 255)"
							font-weight="600"
							font-size="16px"
						/>
					</div>
				</div>

				<!-- ////////////////// -->
				<!-- Нижняя часть блока (Mobile) -->
				<div v-if="device.isMobile" class="idi__elm-info-footer-m">
					<!-- BUTTON - Получить QR-код -->
					<div class="idi__elm-info-footer-m-btn">
						<UiButton
							@click="onGetQrCode"
							label="Получить QR-код"
							:background-color="
								instance.status === STATUS.WAITING ||
								instance.status === STATUS.WAITING_5
									? 'var(--theme-color)'
									: 'rgb(244, 246, 250)'
							"
							:border-color="
								instance.status === STATUS.WAITING ||
								instance.status === STATUS.WAITING_5
									? 'var(--theme-color)'
									: 'rgb(244, 246, 250)'
							"
							color="rgb(255, 255, 255)"
							font-weight="600"
							font-size="16px"
						/>
					</div>
				</div>

				<!-- ICONS (Выйти, рестарт и корзина) -->
				<div v-if="device.isMobile" class="idi__elm-info-footer-m-icons">
					<!-- Icon exit -->
					<div class="idi__elm-info-footer-m-icons-exit">
						<IconExit
							:color="
								instance.status === STATUS.DELETE ||
								instance.status === STATUS.WAITING ||
								instance.status === STATUS.WAITING_5 ||
								instance.status === STATUS.PROCESS
									? 'rgb(234,234,234)'
									: 'rgb(119, 121, 124)'
							"
						/>
						<div
							@click="onLogoutInstance"
							:class="
								instance.status === STATUS.DELETE ||
								instance.status === STATUS.WAITING ||
								instance.status === STATUS.WAITING_5 ||
								instance.status === STATUS.PROCESS
									? 'idi__elm-info-footer-m-icons-exit-label_notactive'
									: 'idi__elm-info-footer-m-icons-exit-label'
							"
						>
							Выйти
						</div>
					</div>
					<!-- Icon restart -->
					<IconRestart
						@click="onRebootInstance"
						:color="
							instance.status === STATUS.DELETE || isClickRebootBtn
								? 'rgb(234,234,234)'
								: '#77797C'
						"
					/>

					<!-- Icon trash -->
					<IconTrash
						v-if="isShowDeleteAction"
						@click="onDeleteInstance"
						:color="
							instance.status !== STATUS.DELETE
								? '#E83941'
								: 'rgb(244, 246, 250)'
						"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import UiStatusIndicator from "@/components/ui/UiStatusIndicator.vue";
import IconExit from "@/components/icons/IconExit.vue";
import IconRestart from "@/components/icons/IconRestart.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import UiButton from "@/components/ui/UiButton.vue";
import { mapActions, mapGetters } from "vuex";
import { IInstanceDetail } from "@/interfaces/IInstanceDetail";
import { IModal } from "@/interfaces/IModal";
import { EventLogField } from "@/enum/EventLogField";
import { IPaidOptions } from "@/interfaces/IPaidOptions";
import { IOptions } from "@/interfaces/IOptions";
import dayjs from "dayjs";
import UiSwitcher from "@/components/ui/UiSwitcher.vue";

@Options({
	components: {
		UiSwitcher,
		UiButton,
		IconTrash,
		IconRestart,
		IconExit,
		UiStatusIndicator,
		IconArrowLeft,
	},

	props: {
		paidOptions: { type: Array, default: [] },
	},

	computed: {
		...mapGetters("instanceModule", {
			device: "getDevice",
			instance: "getInstance",
			optionList: "optionListGetters",
		}),
	},

	methods: {
		...mapActions("instanceModule", [
			"deleteInstanceAction",
			"instanceAction",
			"modalQrCodeAction",
			"qrCodeAction",
			"rebootInstanceAction",
			"logoutInstanceAction",
			"modalEventLogAction",
			"sendEventLogAction",
		]),
		...mapActions("paymentModule", [
			"payActivatedChannelsAction",
			"autoRenewalOptionAction",
			"paidOptionsAction",
		]),
	},
})
export default class InstanceDetailInfo extends Vue {
	public paidOptions: Array<IPaidOptions>;

	public isDisable = false;
	public isClickRebootBtn = false;
	public isClickLogoutBtn = false;

	// Константы
	public STATUS = {
		DELETE: 10,
		ACTIVE: 1,
		WAITING: 2,
		WAITING_5: 5,
		PAUSE: 6,
		PROCESS: 0,
	};

	// ************************************************************
	// Define mapGetters
	public device: { isMobile: boolean };
	public instance: IInstanceDetail;
	public optionList: Array<IOptions>;

	// ************************************************************
	// Define mapActions
	public deleteInstanceAction!: (payload: {
		instance: number;
		token?: string;
		channel?: string;
	}) => Promise<void>;
	public instanceAction!: (payload: {
		instanceId: number;
		channel?: string;
	}) => Promise<void>;
	public modalQrCodeAction!: (payload: IModal) => void;
	public qrCodeAction!: (payload: {
		instance: number;
		token: string;
		channel?: string;
	}) => Promise<void>;
	public rebootInstanceAction!: (payload: {
		instance: number;
		token: string;
		channel?: string;
	}) => void;
	public logoutInstanceAction!: (payload: {
		instance: number;
		token: string;
		channel?: string;
	}) => void;
	public payActivatedChannelsAction!: () => Promise<void>;
	public modalEventLogAction!: (payload: IModal) => void;
	public sendEventLogAction!: (payload: {
		eventLog: {
			instance: number;
			field: string;
			oldValue: string;
			newValue: string;
		};
	}) => Promise<void>;
	public autoRenewalOptionAction!: (payload: {
		instanceId: number;
		optionId: number;
		isActive: number;
	}) => Promise<void>;
	public paidOptionsAction!: (payload: { instanceId: number }) => Promise<void>;

	/**
	 * Hook mounted
	 */
	public mounted() {
		this.isDisable = false;
	}

	/**
	 * Форматирование номера телефона.
	 * Возвращает строку такого вида: +7 (914) 234-34-50
	 * @param num
	 */
	public formatPhoneNumber(num: string | null | undefined) {
		if (num !== null && num !== undefined) {
			return num.replace(
				/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/g,
				`+$1 ($2) $3-$4-$5`
			);
		} else {
			return "";
		}
	}

	/**
	 * Переход на предыдущую страницу
	 */
	public onGoBack() {
		return this.$router.back();
	}

	/**
	 * Удаление инстанса
	 */
	public async onDeleteInstance() {
		// Если инстанс не удалён, тогда выполняем действия
		if (!this.isDisable) {
			this.isDisable = true;
			if (this.instance.status !== this.STATUS.DELETE) {
				const instanceId = Number(this.$route.params.id);

				// Отправляем событие для записи
				await this.sendEventLogAction({
					eventLog: {
						instance: this.instance.instance,
						field: EventLogField["DELETE"],
						newValue: "false",
						oldValue: "true",
					},
				});

				// TODO комментируем, если нужно протестировать запись действий
				await this.deleteInstanceAction({
					instance: instanceId,
					// MAX требует token при удалении, WAPI/TAPI просто игнорируют это поле.
					token: this.instance.token,
					channel: this.currentChannel,
				});

				await this.instanceAction({
					instanceId: instanceId,
					channel: this.currentChannel,
				});
				// Обновим значение счётчика активированных каналов
				await this.payActivatedChannelsAction();
			}
		}
	}

	/**
	 * Получить QR код
	 */
	public async onGetQrCode() {
		if (
			this.instance.status === this.STATUS.WAITING ||
			this.instance.status === this.STATUS.WAITING_5
		) {
			this.modalQrCodeAction({
				isShow: true,
				data: {
					instance: this.instance.instance,
					token: this.instance.token,
					// Канал передаем в модалку, чтобы QR запрашивался у нужного сервиса уже после показа заглушки.
					channel: this.currentChannel,
				},
			});
		}
	}

	/**
	 * Перезагрузка
	 */
	public async onRebootInstance() {
		const isDisable = this.instance.status === this.STATUS.DELETE;

		if (!this.isClickRebootBtn && !isDisable) {
			this.isClickRebootBtn = true;

			// Отправляем событие для записи
			await this.sendEventLogAction({
				eventLog: {
					instance: this.instance.instance,
					field: EventLogField["REBOOT"],
					newValue: "true",
					oldValue: "true",
				},
			});

			// TODO комментируем, если нужно протестировать запись действий
			await this.rebootInstanceAction({
				instance: this.instance.instance,
				token: this.instance.token,
				// Перезагрузка отправляется в WAPI, TAPI или MAX в зависимости от канала.
				channel: this.currentChannel,
			});

			await this.instanceAction({
				instanceId: this.instance.instance,
				channel: this.currentChannel,
			});

			setTimeout(async () => {
				await this.instanceAction({
					instanceId: this.instance.instance,
					channel: this.currentChannel,
				});
				this.isClickRebootBtn = false;
			}, 20000);
		}
	}

	/**
	 * Logout Instance
	 */
	public async onLogoutInstance() {
		const isDisable =
			this.instance.status === this.STATUS.DELETE ||
			this.instance.status === this.STATUS.WAITING ||
			this.instance.status === this.STATUS.WAITING_5 ||
			this.instance.status === this.STATUS.PROCESS;

		if (!this.isClickLogoutBtn && !isDisable) {
			this.isClickLogoutBtn = true;

			// Отправляем событие для записи
			await this.sendEventLogAction({
				eventLog: {
					instance: this.instance.instance,
					field: EventLogField["LOGOUT"],
					newValue: "false",
					oldValue: "true",
				},
			});

			// TODO комментируем, если нужно протестировать запись действий
			await this.logoutInstanceAction({
				instance: this.instance.instance,
				token: this.instance.token,
				// Разлогин отличается endpoint-ом у MAX, поэтому передаем канал.
				channel: this.currentChannel,
			});

			await this.instanceAction({
				instanceId: this.instance.instance,
				channel: this.currentChannel,
			});

			setTimeout(async () => {
				await this.instanceAction({
					instanceId: this.instance.instance,
					channel: this.currentChannel,
				});
				this.isClickLogoutBtn = false;
			}, 20000);
		}
	}

	/**
	 * Модалка. Лог действий
	 */
	public onModalEventLog() {
		this.modalEventLogAction({ isShow: true });
	}

	/**
	 * Открыть ссылку с swagger wapi link
	 */
	public openApiUrlHandler() {
		window.open("https://app.wapi.link/swagger/wapi.html", "_target");
	}

	/**
	 * Возвращает информацию для опции по id
	 * @param optionId
	 */
	public getOptionById(optionId: number): IOptions | string {
		for (let idx = 0; idx < this.optionList.length; idx++) {
			if (this.optionList[idx].id === optionId) {
				return this.optionList[idx];
			}
		}

		return "";
	}

	/**
	 * Форматируем timestamp к виду - 15 августа 10:00
	 * @param timestamp
	 */
	public dataTimeFormat(timestamp: string) {
		if (timestamp !== "") {
			return dayjs(timestamp).format("DD MMMM HH:mm");
		}

		return "";
	}

	/**
	 * Возвращает время истечения инстанса
	 */
	public get instanceExpired() {
		return this.instance.expire_payment_stamp;
	}

	/**
	 * Возвращает время остановки инстанса
	 */
	public get instancePauseStamp() {
		return this.instance.pause_stamp;
	}

	/**
	 * Возвращает время удаления инстанса
	 */
	public get instanceDeletedStamp() {
		return this.instance.delete_stamp;
	}

	/**
	 * Возвращает технический канал инстанса для запросов и отображения.
	 */
	public get currentChannel() {
		// Query приоритетнее данных инстанса, чтобы карточка не перепутала одинаковые id в разных каналах.
		return (this.$route.query.channel as string) || this.instance.channel;
	}

	/**
	 * Возвращает публичный API URL для карточки выбранного канала.
	 */
	public get instanceApiUrl(): string {
		// Для MAX показываем отдельный публичный API host, остальные каналы остаются на api.wapi.link.
		return this.currentChannel === "max"
			? "https://api-max.ru"
			: "https://api.wapi.link";
	}

	/**
	 * Показываем человекочитаемое имя канала в карточке инстанса.
	 */
	public get instanceChannelName(): string {
		if (this.instance.sourceName) {
			return this.instance.sourceName;
		}

		const channel = this.currentChannel || "";
		const channels: { [key: string]: string } = {
			wapi: "WhatsApp",
			whatsapp: "WhatsApp",
			tapi: "Telegram",
			telegram: "Telegram",
			max: "Max",
		};

		return channels[channel.toLowerCase()] || channel.toUpperCase();
	}

	/**
	 * Показывает удаление только для WhatsApp-инстансов.
	 */
	public get isShowDeleteAction(): boolean {
		const channel = String(this.currentChannel || "").toLowerCase();

		return ["wapi", "whatsapp"].includes(channel);
	}

	/**
	 * Checkbox - Автопродление опции
	 */
	public async onCheckboxAutoRenew(val: {
		id: number;
		name: string;
		isActive: boolean;
	}) {
		const instanceId = this.instance.instance;
		const optionId = val.id;

		await this.autoRenewalOptionAction({
			instanceId: instanceId,
			optionId: optionId,
			isActive: val.isActive ? 1 : 0,
		});

		await this.paidOptionsAction({ instanceId: instanceId });
	}
}
</script>

<style scoped lang="scss">
.idi {
	display: flex;
	justify-content: center;

	&__elm {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		max-width: 649px;
	}

	&__elm-backward {
		display: flex;
		padding: 24px 0;
		justify-content: space-between;
		align-items: center;
	}

	&__elm-backward-col {
		display: flex;
	}

	&__elm-backward-col-link {
		cursor: pointer;
	}

	&__elm-backward-col-label {
		padding-left: 12px;
		color: rgb(49, 49, 50);
		font-size: 24px;
		font-weight: 600;
		cursor: pointer;
	}

	&__elm-info {
		display: flex;
		flex-direction: column;
		padding: 24px;
		background: rgb(255, 255, 255);
		border-radius: 12px;
		box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
	}

	&__elm-info-label {
		color: rgb(49, 49, 50);
		font-size: 20px;
		font-weight: 600;
	}

	&__elm-info-item {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 2px;
		align-items: center;
		padding-top: 24px;
		color: rgb(49, 49, 50);
		font-size: 16px;
	}

	&__elm-info-line {
		padding-top: 24px;
		border-bottom: 1px solid rgb(223, 230, 238);
	}

	&__elm-info-footer {
		display: flex;
		padding: 32px 0 12px;
	}

	&__elm-info-footer-item {
		display: flex;
		padding-right: 32px;
		align-items: center;
	}

	&__elm-info-footer-item-icon {
		padding-right: 10px;
	}

	&__elm-info-footer-item-label {
		color: rgb(49, 49, 50);
		cursor: pointer;
	}

	&__elm-info-footer-item-label_notactive {
		color: rgb(228, 228, 229);
	}

	&__elm-info-footer-item-label_red {
		color: rgb(232, 57, 65);
		cursor: pointer;
	}

	&__elm-info-footer-item-label_grey {
		color: rgb(234, 234, 234);
	}

	// Mobile
	&__elm-info-footer-m {
		display: flex;
	}

	&__elm-info-footer-m-btn {
		padding: 24px 0 24px;
		flex-grow: 1;
	}

	&__elm-info-footer-m-icons {
		display: grid;
		grid-template-columns: 1fr 0.3fr 0.1fr;
		gap: 2px;
	}

	&__elm-info-footer-m-icons-exit {
		display: flex;
		align-items: center;
	}

	&__elm-info-footer-m-icons-exit-label {
		margin-left: 10px;
		color: rgb(49, 49, 50);
	}

	&__elm-info-footer-m-icons-exit-label_notactive {
		margin-left: 10px;
		color: rgb(228, 228, 229);
	}

	&__elm-info-option-checkbox {
		display: flex;
		justify-content: space-between;
	}

	@media screen and (max-width: 768px) {
		&__elm {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			padding: 0 12px;
			min-width: 100px;
		}

		&__elm-backward {
			padding: 16px 0;
		}

		&__elm-backward-label {
			padding-left: 0;
			font-size: 18px;
		}

		&__elm-info {
			display: flex;
			flex-direction: column;
			padding: 16px;
			background: rgb(255, 255, 255);
			border-radius: 12px;
			box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
		}

		&__elm-info-item {
			display: flex;
			align-items: center;
			padding: 0 0 12px;
			font-size: 16px;
		}

		&__elm-info-footer-item-label {
			color: rgb(49, 49, 50);
			cursor: pointer;
		}

		&__elm-info-item-key {
			color: rgb(119, 121, 124);
			margin-right: 10px;
		}

		&__elm-info-item-val {
			word-break: break-all;
		}

		&__elm-info-line {
			padding-top: 0;
		}

		&__elm-info-option {
			display: grid;
			grid-template-columns: 0.5fr 1fr 0.1fr;
			gap: 2px;
			align-items: center;
			padding-bottom: 12px;
			color: rgb(49, 49, 50);
			font-size: 16px;
		}

		&__elm-info-option-checkbox-title {
			display: none;
		}
	}

	// Desktop
	@media screen and (min-width: 768px) {
		&__elm-info-option {
			display: grid;
			grid-template-columns: 0.3fr 0.5fr 0.6fr;
			gap: 2px;
			align-items: center;
			padding-top: 24px;
			color: rgb(49, 49, 50);
			font-size: 16px;
		}
	}
}
</style>
